// This file is automatically generated from Rails routes.
// DO NOT modify it manually.
// To regenerate, run: bin/rake gitlab:js:routes

import { __jsr } from '~/lib/utils/path_helpers/core';
import { resolveOrganizationScope } from '~/lib/utils/path_helpers/utils';


/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/users(.:format)`
 * - Path helper: `autocomplete_users_path`
 * - URL helper: `autocomplete_users_url`
 * - controller#action: `autocomplete#users`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteUsersPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteUsersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteUsersPath(organizationPath, ...routeArgs);
  }

  return _autocompleteUsersPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/users/:id(.:format)`
 * - Path helper: `autocomplete_user_path`
 * - URL helper: `autocomplete_user_url`
 * - controller#action: `autocomplete#user`
 *
 * @param {any} id
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteUserPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteUserPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);
  const _autocompleteUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteUserPath(organizationPath, ...routeArgs);
  }

  return _autocompleteUserPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/projects(.:format)`
 * - Path helper: `autocomplete_projects_path`
 * - URL helper: `autocomplete_projects_url`
 * - controller#action: `autocomplete#projects`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteProjectsPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteProjectsPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteProjectsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"projects"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteProjectsPath(organizationPath, ...routeArgs);
  }

  return _autocompleteProjectsPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/award_emojis(.:format)`
 * - Path helper: `autocomplete_award_emojis_path`
 * - URL helper: `autocomplete_award_emojis_url`
 * - controller#action: `autocomplete#award_emojis`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteAwardEmojisPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteAwardEmojisPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"award_emojis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteAwardEmojisPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"award_emojis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteAwardEmojisPath(organizationPath, ...routeArgs);
  }

  return _autocompleteAwardEmojisPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/merge_request_target_branches(.:format)`
 * - Path helper: `autocomplete_merge_request_target_branches_path`
 * - URL helper: `autocomplete_merge_request_target_branches_url`
 * - controller#action: `autocomplete#merge_request_target_branches`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteMergeRequestTargetBranchesPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteMergeRequestTargetBranchesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"merge_request_target_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteMergeRequestTargetBranchesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"merge_request_target_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteMergeRequestTargetBranchesPath(organizationPath, ...routeArgs);
  }

  return _autocompleteMergeRequestTargetBranchesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/merge_request_source_branches(.:format)`
 * - Path helper: `autocomplete_merge_request_source_branches_path`
 * - URL helper: `autocomplete_merge_request_source_branches_url`
 * - controller#action: `autocomplete#merge_request_source_branches`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteMergeRequestSourceBranchesPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteMergeRequestSourceBranchesPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"merge_request_source_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteMergeRequestSourceBranchesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"merge_request_source_branches"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteMergeRequestSourceBranchesPath(organizationPath, ...routeArgs);
  }

  return _autocompleteMergeRequestSourceBranchesPath(...routeArgs);
};

/**
 * Generates the Rails route:
 *
 * - href: `/-/autocomplete/deploy_keys_with_owners(.:format)`
 * - Path helper: `autocomplete_deploy_keys_with_owners_path`
 * - URL helper: `autocomplete_deploy_keys_with_owners_url`
 * - controller#action: `autocomplete#deploy_keys_with_owners`
 *
 * @param {object | undefined} options
 * @param {string | null | undefined} options.organizationPath Path of organization to nest under. Pass `null` to remove path from URL params when outside of an organization data context.
 * @returns {string} route path
 */
export const autocompleteDeployKeysWithOwnersPath = /*#__PURE__*/ (...args) => {
  const _organizationAutocompleteDeployKeysWithOwnersPath = /*#__PURE__*/ __jsr.r({"organization_path":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"o"],[2,[7,"/"],[2,[3,"organization_path"],[2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"deploy_keys_with_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);
  const _autocompleteDeployKeysWithOwnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"-"],[2,[7,"/"],[2,[6,"autocomplete"],[2,[7,"/"],[2,[6,"deploy_keys_with_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

  const { organizationPath, routeArgs } = resolveOrganizationScope(args);

  if (organizationPath) {
    return _organizationAutocompleteDeployKeysWithOwnersPath(organizationPath, ...routeArgs);
  }

  return _autocompleteDeployKeysWithOwnersPath(...routeArgs);
};

